<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
  >
    <g class="a" fill="none" :stroke="iconColor">
      <circle class="c" stroke="none" cx="5" cy="5" r="5" />
      <circle class="d" fill="none" cx="5" cy="5" r="4.5" />
    </g>
    <g class="a" fill="none" :stroke="iconColor" transform="translate(13)">
      <circle class="c" stroke="none" cx="5" cy="5" r="5" />
      <circle class="d" fill="none" cx="5" cy="5" r="4.5" />
    </g>
    <circle
      class="b"
      :fill="iconColor"
      cx="5"
      cy="5"
      r="5"
      transform="translate(0 13)"
    />
    <g class="a" fill="none" :stroke="iconColor" transform="translate(13 13)">
      <circle class="c" stroke="none" cx="5" cy="5" r="5" />
      <circle class="d" fill="none" cx="5" cy="5" r="4.5" />
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'

  export default {
    name: 'Sections_Icon',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#50514e'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 23px;
    height: 23px;
  }
</style>
